export const CLEAR_TOURNEY_STANDINGS_INBOUND_DEFINITION = {
    definitionParts: []
};
